import React, { useEffect } from 'react';
import { OnboardingStep1InputArea } from './OnboardingStep1InputArea';
import styled from 'styled-components';
import { UpdateWorkspace } from '../../../../shared/types/workspaceTypes';
import { FlexRow } from '../../../../shared/FlexRow';
import { FilledButton, TextButton } from '../../../../shared/styled-components/styled_buttons';
import { OnboardingProgress } from './OnboardingProgress';
import { OnboardingStep1Preview } from './OnboardingStep1Preview';
import { useTrack } from '@hackler/react-sdk';

interface Props {
  data: UpdateWorkspace;
  onChange: (data: UpdateWorkspace) => void;
  onPrev: () => void;
  onNext: () => void;
}

export const OnboardingStep1: React.FC<Props> = ({ data, onChange, onPrev, onNext }) => {
  const track = useTrack();

  useEffect(() => {
    track({ key: 'view_workspaces_step1' });
  }, []);

  const handleInputClick = (name: string) => {
    if (name === 'address_search') {
      track({ key: `click_${name}` });
      return;
    }
    track({ key: `click_input_${name}` });
  };

  return (
    <Container>
      <InputWrapper>
        <OnboardingProgress step={1} />
        <OnboardingStep1InputArea data={data} handleInputClick={handleInputClick} onChange={onChange} />
        <FlexRow width={'100%'} justify={'space-between'} align={'center'}>
          <TextButton
            size={'m'}
            color={'mono'}
            icon={{ src: '/images/common/chevron.svg', slot: 'start' }}
            onClick={() => {
              onPrev();
            }}
          >
            이전
          </TextButton>
          <FilledButton
            size={'m'}
            color={'primary'}
            icon={{ src: '/images/common/chevron.svg', slot: 'end', rotate: '180deg' }}
            disabled={!data.name || !data.contact.officer_contact || !data.location?.address || !data.location?.address_detail}
            onClick={() => {
              if (!data.name || !data.contact.officer_contact || !data.location?.address || !data.location?.address_detail) return;
              onNext();
            }}
          >
            다음
          </FilledButton>
        </FlexRow>
      </InputWrapper>
      <OnboardingStep1Preview data={data} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 4rem 2.4rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 3.2rem;
`;

const InputWrapper = styled.div`
  width: 49.8rem;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 3.2rem;
`;
